export default "__VITE_ASSET__B1z$VeQe__"